import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DashboardFramelessComponent} from './dashboard-frameless/dashboard-frameless.component';


const routes: Routes = [
  {path: 'dashboard/:dashboardName', component: DashboardComponent},
  {path: 'dashboard-frameless/:dashboardName', component: DashboardFramelessComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardsRoutingModule { }
